
// @фts-nocheck // постепенно покрываем типами. Чтобы проверка заработала, надо испортить @ts-nocheck например
import axios from 'axios';
import ctrls from './controls/_index.js';

import { getFieldValue } from './utils.js';
import metaUtil from './util-meta.js';
import urlUtil from './util-url.js';
import formdataUtil from './util-formdata.js';
import journalUtil from './util-journal.js';
import preprocessUtil from './util-api-data-preprocess';

import tip from './tip.vue';

import List from './p_list.vue';
import draftCommon from './components/Draft/draft-common.js';

import { ChildNavBar, ReportExcel, DraftSplashScreen, DraftSaver, ExportWord, InexFeedback } from './components/';
import childNavMixin from './mixins/child-nav-mixin.js';
import _ from 'lodash';

import { copyTextToClipboard, has, getEmptyValueDisplay } from './utils.js'; //@utils
import { UarmListTreeLevel } from '@uarmSrc/util-tree';
import { CardMetaItem, ListMetaItem, UarmArm, UarmRecordResponse, UarmRecordField } from './types.js';

import ChartLoader from '@ooo-inex/charts-component';

export default {
	name: 'arm_view_card',
	data: function () {
		// @ts-ignore
		return this.getInstanceData();
	},
	props: {
		arm_id: {
			// можно передать арм_ид в пропсах и он будет иметь приоритет на тем что в route
			type: Number,
		},
		record_id: {
			// пропс нужен для попапов: если передать нолик, будет создание записи, если цифру - карточка
		},
		/** ID родительской записи, с которым была открыта карточка (т.е. смена родителя в карточке не влияет) */
		parent_record_id: {
			type: Number,
			default: null,
		},
		pick_type: {
			// в случае когда арм грузится в попапе (загрузка картинки в TinyMCE) здесь будет строка
			type: String,
			default: function () {
				return this.$route.query.pick_type;
			},
		},
		modalMode: {
			type: Boolean,
			default: false,
		},
		autoCreateRecord: {
			type: Boolean,
			default: false,
		},
		targetColumn: {
			type: String,
			default: null,
		},
		parentFields: {
			// данные для вывода в карточку мультитабличного АРМа, полученные при открытии из попапа (PIRS-2-11881)
			type: Array,
			default: () => [],
		},
	},
	components: Object.assign(
		{
			ChildNavBar,
			ReportExcel,
			DraftSplashScreen,
			DraftSaver,
			ExportWord,
			tip,
			List,
			InexFeedback,
			ChartLoader,
		},
		ctrls,
	),
	watch: {
		errText: function () {
			// угу, такой странный способ обеспечить видимость ошибки
			window.scroll(0, 0);
		},
		dynamicFieldGroups(value) {
			if (this.isDynamicFields) {
				const index = this.cardMeta.findIndex(
					(f) => f.hasOwnProperty('isDynamicFieldGroup') && f.isDynamicFieldGroup === true,
				);

				if (index > -1) {
					this.$set(this.cardMeta[index], 'srv_options', value);
				}
			}
		},
	},
	computed: {
		itemType() {
			return Object.freeze({
				// FIELD: 'Field',
				DELIMITER: 'Delimiter',
			});
		},
		c_loadingAny() {
			return this.loadingMeta || this.loadingRecordData;
		},
		linkAnalyzed() {
			const { query } = this.$route;
			return query.hasOwnProperty('linkAnalyzed') ? Boolean(query['linkAnalyzed']) : false;
		},
		showExecutedSql() {
			// return true
			return (
				has(this.armMeta, 'sqlTraceParameters.showExecutedSql') &&
				this.armMeta['sqlTraceParameters']['showExecutedSql'] === true
			);
		},
		showExecutedSqlParams() {
			return (
				this.showExecutedSql &&
				has(this.armMeta, 'sqlTraceParameters.showExecutedSqlParams') &&
				this.armMeta['sqlTraceParameters']['showExecutedSqlParams'] === true
			);
		},
		isDynamicFields() {
			return has(this.armMeta, 'isDynamicFields') && this.armMeta.isDynamicFields === true;
		},
		/**
		 * Значение единственного (?) поля, которое используется как критерий для показа динамических групп полей
		 * Значение должно совпадать с ID записи из "Псевдо-справочника" (dictionaries)
		 */
		dynamicFieldGroup() {
			const field = this.cardMeta.find((f) => has(f, 'isDynamicFieldGroup') && f.isDynamicFieldGroup === true);
			return this.isDynamicFields && field ? field['value'] : null;
		},
		dynamicFieldGroups() {
			let groups: any[] = [];
			if (this.isDynamicFields) {
				const field = this.armMeta.fields.find(
					(f) => f.hasOwnProperty('isDynamicFieldGroup') && f.isDynamicFieldGroup === true,
				);
				if (field && has(field, 'dictionaries') && Array.isArray(field.dictionaries)) {
					const { dictionaries } = field;
					// groups = _.uniqBy(_.filter(dictionaries, 'id'), 'id')
					groups = dictionaries.filter(
						(d) =>
							has(d, 'isNotAddable') === false ||
							(has(d, 'isNotAddable') && d.isNotAddable === false) ||
							(has(d, 'isNotAddable') && !d.isNotAddable),
					);

					if (this.isNewRecord === false) {
						const group = dictionaries.find((g) => String(g.id) === String(this.dynamicFieldGroup));
						if (has(group, 'isNotAddable') && group['isNotAddable'] === true) {
							groups.push(group);
						}
					}
				}
			}

			return groups;
		},
		childArms() {
			return this.armMeta.childArms.filter((c) => this.checkChildArm(c));
		},
		hasMetaChanged() {
			const { cardMeta, cardMetaDefault } = this.$data;
			if (this.armMeta.btnSubmitDisabled && cardMeta && cardMetaDefault) {
				// CWP-18691 - разблокировать кнопку Сохранить при изменении данных в карточке
				let cmd = cardMetaDefault.map((c) => {
					return { value: c.value, dbcolname: c.dbcolname };
				});
				let cm = cardMeta.map((c) => {
					return { value: c.value, dbcolname: c.dbcolname };
				});
				return !_.isEqual(cmd, cm);
			}
			return false;
		},
		hasChart() {
			return this.armMeta.chartsComponent?.enabled || false;
		},
		chartUrl() {
			let url = '/ru/page/' + this.armMeta.chartsComponent?.pageId;
			if (this.id) {
				url += '?id=' + this.id;
			}
			return url;
		},
		chartStyle() {
			return 'margin: 20px 0;';
		},
		lineHeight() {
			return 350;
		},
		chartHeight() {
			return 350;
		},
	},
	methods: {
		/**
		 * Построение списка элементов-строк карточки АРМ (это не только поля, но и разделители). И те и другие предобрабатываются в buildFields
		 * Поля фильтруются по checkFieldDynamicGroup в checkField
		 * Разделители фильтруются по checkFieldDynamicGroup прямо здесь, так вот криво получилось, чтобы не сломать :(
		 */
		buildItems() {
			return [...this.$data.cardMeta, ...this.$data.delimiters.filter(this.checkFieldDynamicGroup)].sort(
				orderComparator,
			);
		},
		/** Внутри некоторых контролов можно получить метаданные всех полей карточки. Белый список этих контролов - в arrAccessibleControls. Сделано так, по всей видимости, чтобы не треснула память (не факт что треснет, что вообще это на что-то повлияет) */
		getCardMeta(field) {
			const whiteListedCtrlCodes = ['map_geocoder', 'geo_single', 'dropdown_page', 'dropdown_address', 'popup_picker'];
			// TODO перенести атрибут "доступны данные записи" в метаданные контрола или просто забить

			if (
				whiteListedCtrlCodes.includes(field.ctrlCode) ||
				(field.ctrlCode === 'text_input' && field.ctrlParams.encryptionFlag)
			) {
				return this.$data.cardMeta;
			}

			return null;
		},
		getInstanceData: function () {
			var vm = this;
			var armId = (vm.$props.arm_id || vm.$route.params.armId) | 0;
			if (!armId) {
				throw new Error('armId is undefined');
			}

			if (!armId) {
				throw new Error('armId is undefined');
			}
			var recordId;
			if (typeof vm.$props.record_id !== 'undefined') {
				// проверка такая потому что может быть нолик в случае новой записи
				recordId = vm.$props.record_id;
			} else {
				recordId = vm.$route.params.recordId | 0;
			}
			var siteId = vm.$route.params.vpId | 0;
			if (!window.UARM_VPID) {
				window.UARM_VPID = siteId;
			}
			return {
				armId,
				siteId,
				recordId,
				is_wizard: urlUtil.isWizard,
				isNewRecord: !recordId, // !vm.$route.query.record_id,
				armMeta: {},
				/** Изначально полученные (!!!) данные, краткая версия (только value). Текущие - в cardMeta */
				recordData: {},
				errText: '',
				loadingMeta: true,
				loadingRecordData: false,
				recordSavePending: false, // formdataUtil_doSubmit сама ставит и снимает это свойство!
				nothingFound: false,
				/** Актуальные в отличие от recordData */
				cardMeta: [],
				delimiters: [],
				childNav_pathArray: vm.childNav_getPathArray(),
				isNotPopup: !vm.$props.pick_type && !vm.$props.modalMode,
				fieldsIsBuilt: false,
				recordCvpmId: null,
				draftProp: {
					armId,
					siteId,
					recordId,
					initialFieldsStr: '', // смысл stringify/parse - экономия
				},
				_draftFullValues: {},
				draftCreated: false,
				splashDraftList: [],
				brokenLinks: {},
				childMultipleArms: [],
				_bufferMailingControl: null, // PIRS-2-12326 - для проверки, есть ли требуемый контрол поджига
				/** Изначально полученные данные, краткая версия (только value). Текущие - в cardMeta */
				cardMetaInitial: {},
			};
		},
		handleMailBuffering() {
			// PIRS-2-12326 - динамическая активация/деактивация галочки поджига
			if (!this.$data._bufferMailingControl) {
				return;
			}

			const hasChanged = this.cardMeta
				.filter(({ defaultValue }) => defaultValue)
				.some(({ defaultValue, value }) => defaultValue !== value);

			const hasEnouthChildRecords = !this.armMeta.isMultipleArm || !!this.$refs.listInCard[0].listItems.length;

			// Рассылка готова к отправке, если было изменение в карточке ИЛИ есть дочерние записи
			const isReady = hasChanged || hasEnouthChildRecords;

			this.$data._bufferMailingControl.disabled = !isReady;
			if (!isReady) {
				this.$data._bufferMailingControl.value = false;
			}
		},
		onMount: function () {
			this.fetchMetaData(); // fetchRecordData будет в коллбеке
		},
		// коммент для поиска: goToList
		gotoFilterlist: function (optArg: GotoFilterlistArg = {}) {
			const opt: GotoFilterlistArg = optArg.isOpt ? optArg : {};
			if (this.modalMode) {
				this.$emit('close');
			} else if (this.linkAnalyzed) {
				this.$router.go(-1);
			} else {
				const armMeta: UarmArm = this.$data.armMeta;
				// preventUarmListMemSet!==true при нажатии кнопки возврат
				if (armMeta.isTreeViewByLevel && !opt.preventUarmListMemSet) {
					const cardMeta: CardMetaItem[] = this.$data.cardMeta;
					const treeLevelInitial = getFieldValue(cardMeta, 'tree_level');
					UarmListTreeLevel.setLevelValue(this.armId, treeLevelInitial as number);
					const idPathInitial = getFieldValue(cardMeta, 'id_path');
					UarmListTreeLevel.setIdPathValue(this.armId, idPathInitial as string);
				}
				this.$router.push({
					name: 'ArmView_List',
					params: {
						armId: this.armId,
						vpId: this.siteId,
						specMode: this.$route.params.specMode,
					},
					query: this.$route.query,
				});
			}
		},
		// Получение предметных данных записи с последующей загрузкой в форму
		// (в случае новой записи - сразу загрузка в форму пустых данных)
		fetchRecordData: function () {
			var vm = this;

			if (vm.$data.isNewRecord) {
				vm.buildFields();

				if (this.autoCreateRecord) {
					const readyToSubmit = this.cardMeta.filter(({ required }) => required).every(({ value }) => value);

					if (readyToSubmit) {
						this.cardSubmit();
					}
				}

				return;
			}

			const { armId } = vm.$data;
			const { specMode } = vm.$route.params;
			// !!! по уму надо использовать urlUtil.getServiceUrl()
			let apiUrl = urlUtil.getDomain() + urlUtil.getPath({ specMode });
			apiUrl += vm.$data.siteId + '/' + armId + '/data';
			apiUrl += '/' + this.recordId;

			// Передаем ID родительского арма - PIRS-2-10938
			if (vm.$route.query.parentArmId) {
				apiUrl += `${apiUrl.indexOf('?') > -1 ? '&' : '?'}parent_arm_id=${vm.$route.query.parentArmId}`;
			}

			vm.$data.loadingRecordData = true;
			var rawItemFields;
			axios
				.get(apiUrl)
				.then(function (res) {
					var rawItem = res.data.records[0];
					rawItemFields = rawItem.fields;
					vm.$data.splashDraftList = rawItem.drafts;
					vm.$data.recordData = preprocessUtil(rawItem);
					vm.$emit('unpend');
				})
				.catch(function (thrown) {
					// ахтунг! в p_list.vue и p_card.vue находятся одинаковые обработчики ошибок запроса данных (плюс аналогичный - в util-meta.js)
					console.log(thrown);
					if (axios.isCancel(thrown)) {
						console.log('Axios request canceled', thrown.message);
					} else {
						var thrownMsg;
						var humanErrString = '[HUMAN_ERROR]';
						if (thrown && thrown.response) {
							var status = thrown.response.status;
							if (status === 401) {
								document.dispatchEvent(new Event('need-auth'));
								// cms-app слушает это событие и перезагружает страницу, чтобы появилась форма авторизации
							}
							if (status === 403) {
								if (window.UARM_AUTH_CHECK) {
									window.UARM_AUTH_CHECK(true);
								}
								thrownMsg = 'Ошибка доступа к АРМ № ' + armId + ' (код 403)';
							} else if (status === 404) {
								thrownMsg = 'Данные АРМ № ' + armId + ' не найдены';
							} else {
								thrownMsg =
									'Ошибка ' + status + '. \n' + ((thrown.response.data && thrown.response.data.message) || '');
							}
						} else if (thrown.message && thrown.message.indexOf(humanErrString) === 0) {
							// для эксепшенов которые содержат текст кот надо показать
							thrownMsg = thrown.message.replace(humanErrString, '');
						} else {
							thrownMsg = 'Ошибка получения данных записи';
						}
						const userLogin = window.PAGEDATA?.login;
						if (userLogin) {
							thrownMsg += `\nЛогин: ${userLogin}`;
						}
						const rid = thrown?.response?.data?.rid || thrown?.rid || '<none>';
						if (rid) {
							thrownMsg += `\nИдентификатор запроса: ${rid}`;
						}
						vm.$data.errText = thrownMsg;
					}
				})
				.then(function () {
					vm.$data.loadingRecordData = false;
					vm.buildFields();
					vm.$data.draftProp.initialFieldsStr = draftCommon.getEnrichedInitialFields(rawItemFields, vm.$data.cardMeta);
					// vm.armMeta.btnSubmitDisabled = null;
					if (vm.armMeta.btnSubmitDisabled) {
						vm.$data.cardMetaDefault = _.cloneDeep(vm.$data.cardMeta);
					}
				});
		},
		// Получение метаданных АРМ
		fetchMetaData: function () {
			var vm = this;
			var getMetaParams = {
				armId: vm.$data.armId,
				vpId: vm.$data.siteId,
				isCard: true,
				specMode: this.$route.params.specMode,
				parentArmId: undefined,
			};

			// Передаем ID родительского арма - PIRS-2-10938
			if (this.$route.query.parentArmId) {
				getMetaParams.parentArmId = this.$route.query.parentArmId;
			}

			const metaCallback = (armMeta) => {
				journalUtil.enrichArmMeta(armMeta); // здесь если у АРМ есть признаки журналирования, в его armMeta.childArms добавляются фиктивные дочерние АРМ

				if (vm.isNotPopup && window.UARM_CHANGE_PAGE_TITLE) {
					var domainArr = window.location.hostname.split('.');
					// для наших ПТК пишем в тайтл чтобы проще ориентироваться
					var ptkPrefix = domainArr.length === 4 ? domainArr[1] + ': ' : '';
					document.title = ptkPrefix + 'АРМ «' + armMeta.caption + '» (' + armMeta.id + ')';
				}

				if (vm.$props.targetColumn && !armMeta.fields.find(({ dbcolname }) => dbcolname === vm.$props.targetColumn)) {
					// Добавляем в форму колонку FK для дочернего АРМ в попап-режиме, если этой колонки нет
					armMeta.isSubmitDisabled = true;
					armMeta.fields.unshift({
						name: 'ID родительской записи',
						dbcolname: vm.$props.targetColumn,
						card: {
							ctrlCode: 'number_input',
							ctrlParams: {
								defaultValue: 0,
								isReadOnly: true,
								isHidden: true,
							},
						},
					});
				}

				vm.$data.armMeta = armMeta;
				vm.$data.childMultipleArms = armMeta.childArms.filter(({ childMultipleArm }) => childMultipleArm);
				vm.loadingMeta = false; // TODO перенести ниже в always
				// Получаем предметные данные записи
				vm.fetchRecordData();
			};

			metaUtil
				.getItem(getMetaParams)
				.then(metaCallback)
				.catch(function (thrown) {
					const thrownStr = thrown && thrown.toString ? thrown.toString() : void 0; // исключения при прямом выводе становятся тупо {}
					vm.$data.errText = thrownStr || 'Ошибка получения метаданных АРМ ' + vm.$data.armId;
				})
				.then(function (xhr) {
					// always
					//vm.loadingMeta = false;
				});
		},
		// Составление списка полей (cardMeta) и загрузка данных в контролы
		buildFields: function (alternativeRecordDataSource) {
			var vm = this;
			var recordDataSource = alternativeRecordDataSource || vm.$data.recordData;
			var parentFieldToSet = this.childNav_getParentFieldToSet();

			// Добавляем отображение нужных значений родительского АРМа - PIRS-2-11881
			if (vm.$props.parentFields.length) {
				for (const { name, value, dbcolname } of vm.$props.parentFields) {
					vm.$data.cardMeta.push({
						name,
						ctrlParams: {},
						dbcolname,
						ctrlCode: 'text_static',
						value,
						RANDOM_KEY: Math.floor(Math.random() * 1e17),
					});
				}
			}

			//console.log('kmax=' + this.armMeta.fields.length);
			for (var k = 0; k < this.armMeta.fields.length; k++) {
				//console.log('k = ' + k)
				var fieldMeta = this.armMeta.fields[k];

				if (fieldMeta.card && fieldMeta.card.ctrlCode) {
					let ctrlCode = fieldMeta.card.ctrlCode;
					let ctrlParams = fieldMeta.card.ctrlParams;
					let defaultValue = fieldMeta.card.ctrlParams.defaultValue;
					/*
						Закомментировал, пока берем умолчательное значение не из контрола (хз зачем) а из его параметров, суть свойств поля арм (ctrlParams.defaultValue)
						ctrls[ctrlCode].props.value.default;
						if (typeof defaultValue === 'function') {
							// потому что если дефолтное значение пропса {} или []
							// то вуй не может просто взять и сделать его и просит функцию
							// которая вернет {} или []

							// TODO!!!! выполнять через apply с контекстом - инстансом (но как?)
							defaultValue = defaultValue(); // ????? прерывает выполнение!!!!! ЧТО ЗА ХЕРНЯ
						}
						*/

					let dbcolname = fieldMeta.dbcolname;

					let value;
					let likeStatic = false;

					// • Карточка, открытая из списка родительского АРМа в попапе: значение FK прокинуто извне
					if (this.modalMode && this.parent_record_id && dbcolname === this.targetColumn) {
						likeStatic = true; // Поле не статическое, чтобы отправить, но выглядеть должно как статика
						value = this.parent_record_id;
					}
					// • для деревянных армов: если я в списке нажал на кнопку "создать вложенную запись"
					else if (this.$route.query.tree_parent_id && dbcolname === 'parent_id') {
						value = this.$route.query.tree_parent_id;
					}
					// • Значение берется дефолтное для экземпляра контрола
					// (если оно не задано, берется умолчательное значение пропса value из самого контрола)
					else if (vm.$data.isNewRecord && typeof defaultValue !== 'undefined' && defaultValue !== '') {
						value = defaultValue;
					}
					// • Значение берется из параметров которые присутствуют в урле (хеше)
					// Устанавливаем значение ссылочной колонки родителя, если АРМ дочерний
					// аналогичное действие случается при отправке, чтобы правильно
					// работали АРМ где нет контрола на этой колонке
					else if (parentFieldToSet.name === dbcolname) {
						value = parentFieldToSet.value;
					}
					// • Нормальная картчока - значение берем из данных записи
					else {
						value = recordDataSource[fieldMeta.dbcolname];
					}

					// скрытый серверный контрол Пользователь
					var isHiddenCtrl_userData = ctrlCode === 'user_data' && !ctrlParams.bDisplayValue;
					// скрытый контрол Рассылка всегда
					var isHiddenCtrl_alwaysMailing = ctrlCode === 'mailing_init' && ctrlParams.alwaysMailing;
					var isHiddenCtrl_alwaysHook = ctrlCode === 'hook_init' && ctrlParams.alwaysHook;
					// любой скрытый контрол со свойством isInvisible
					// предполагаетя что его данные используются другим контролом
					var isHiddenCtrl_isInvisible = !!ctrlParams.isInvisible;
					const isHiddenCtrl_emptyValue = getEmptyValueDisplay(vm.$data.isNewRecord, ctrlParams, value).needToHide;

					if (
						this.isDynamicFields &&
						has(fieldMeta, 'isDynamicFieldGroup') &&
						fieldMeta['isDynamicFieldGroup'] === true
					) {
						fieldMeta.srv_options = vm.dynamicFieldGroups;
					}

					if (
						!isHiddenCtrl_userData &&
						!isHiddenCtrl_alwaysMailing &&
						!isHiddenCtrl_isInvisible &&
						!isHiddenCtrl_alwaysHook &&
						!isHiddenCtrl_emptyValue
					) {
						const builded: CardMetaItem = {
							name: fieldMeta.name,
							description: fieldMeta.description,
							ctrlParams,
							srv_options: fieldMeta /*.card*/.srv_options, // коммент для поиска "srv_options переехали" PIRS2018-169
							dbcolname,
							dbcoltype: fieldMeta.dbcoltype,
							ctrlCode,
							value,
							disabled: false,
							likeStatic,
							required: fieldMeta.required,
							order: fieldMeta.order,
							RANDOM_KEY: Math.floor(Math.random() * 1e17),
							dynamicFieldGroup: fieldMeta.dynamicFieldGroup,
							isDynamicFieldGroup: fieldMeta.isDynamicFieldGroup,
							defaultValue: ctrlParams.defaultValue,
						};

						// PIRS-2-12326 - контрол поджига с буферизацией
						if (
							ctrlCode === 'mailing_init' &&
							ctrlParams.mailingList &&
							ctrlParams.mailingList.find(({ bufferMailing }) => bufferMailing)
						) {
							vm.$data._bufferMailingControl = builded;
							builded.disabled = true;
						}

						vm.$data.cardMeta.push(builded);
					}
				} else {
					// vm.$data.cardMeta.push(null) // зачем был null?
				}
			}

			for (const delimiter of this.armMeta.delimiters || []) {
				vm.$data.delimiters.push({
					...delimiter, // name, order, backgroundColor, textColor, fontSize
					RANDOM_KEY: Math.floor(Math.random() * 1e17),
					type: vm.itemType.DELIMITER,
				});
			}
			vm.$data.delimiters.sort(orderComparator); // не нужно? тк buildItems

			vm.$data.cardMeta.sort(orderComparator); // не нужно? тк buildItems

			if (vm.$data.isNewRecord) {
				// После отрисовки (нексттик) делаем фокус на первом фокусабельном поле
				vm.$nextTick(function () {
					for (var j = 0; j < vm.$children.length; j++) {
						var _child = vm.$children[j];
						var child = _child instanceof Array ? _child[0] : _child;
						// var inputRef = child.$refs.inputRef instanceof Array ? child.$refs.inputRef[0] : child.$refs.inputRef;
						if (child.$refs.inputRef && child.$refs.inputRef.focus) {
							// if meta - чтобы взять только контролы
							// console.log('Фокус на поле', child.$refs.inputRef)
							child.$refs.inputRef.focus();
							break;
						} else if (child.EXT_triggerFocus) {
							// для контрола мультивыбор
							child.EXT_triggerFocus();
						}
					}
				});
			}
			vm.$data.recordCvpmId = vm.$data.isNewRecord ? vm.$data.siteId : vm.$data.recordData.ITEM_CVPM_ID || null;
			vm.$data.fieldsIsBuilt = true;
		},
		// Документация здесь:
		// http://172.22.2.36:8080/swagger-ui.html#/resource-controller
		cardSubmit: function () {
			var vm = this;
			const armMeta: UarmArm = vm.$data.armMeta;

			var submitArg = this.getFormdataArg();

			if (this.modalMode) {
				submitArg.notNotify = true;
			}

			submitArg.successCallback = function (res) {
				const { records, sqlTraces }: { records: UarmRecordResponse[]; sqlTraces: any } = res.data;

				if (vm.showExecutedSql && sqlTraces) {
					const sql = sqlTraces.map((s) => s.sql);
					const sqlText = sql.join(';');
					const name = `${vm.$data.isNewRecord ? 'create_record' : `update_${vm.$data.recordId}`}_arm_${
						vm.$data.armId
					}`;

					console.log(`SQL-запрос для генерации миграции: ${sqlText}`);
					copyTextToClipboard(sqlText);

					if (vm.is_wizard) {
						vm.$root.$emit('generate-migration', { sql, name, db: 'content-db' });
					}
				}

				// При создании и обновлении записи для UarmListTreeLevel нам нужно знать новый tree_level
				// прям всё грузить в контролы побоялся, поэтому далем memSet здесь и через preventUarmListMemSet предотвращаем дальнейшее
				let preventUarmListMemSet = false;
				if (armMeta.isTreeViewByLevel) {
					const cardMeta: CardMetaItem[] = vm.$data.cardMeta;

					const treeLevelInitial = getFieldValue(cardMeta, 'tree_level');
					const treeLevelNew = getFieldValue(records[0]?.fields, 'tree_level');
					const treeLevelIsNew = treeLevelInitial !== treeLevelNew;
					/* Сохраняем treeLevel. кейс 1: создание записи, кейс 2: обновление tree_level записи */
					if (vm.isNewRecord || treeLevelIsNew) {
						console.log(
							`UarmListTreeLevel. Сохраняем treeLevel. кейс 1: создание записи, кейс 2: обновление tree_level записи Берём tree_level из ответа сервера: «${treeLevelNew}»`,
						);
						UarmListTreeLevel.setLevelValue(this.armId, treeLevelNew as number);
						preventUarmListMemSet = true;
					}
					const idPathInitial = getFieldValue(cardMeta, 'id_path');
					const idPathNew = getFieldValue(records[0]?.fields, 'id_path');
					const idPathIsNew = idPathInitial !== idPathNew;
					if (vm.isNewRecord || idPathIsNew) {
						console.log(
							`UarmListTreeLevel. Сохраняем idPath. кейс 1: создание записи, кейс 2: обновление id_path записи. Берём id_path из ответа сервера.`,
						);
						UarmListTreeLevel.setIdPathValue(this.armId, idPathNew as string);
						preventUarmListMemSet = true;
					}
				}

				if (vm.$props.pick_type) {
					vm.$emit('popup_upsert', records); // при добавлении записи в попапе, например новый файл с диска в тинимце
				} else if (vm.$props.modalMode) {
					vm.$emit('restart', records[0] ? records[0].primaryKeyValue : 0); // Если запись создается автоматически, перестраиваем содержимое карточки
				} else {
					vm.gotoFilterlist({ preventUarmListMemSet });
					vm.$notify({
						type: 'success',
						text: vm.$data.isNewRecord
							? 'Запись успешно создана'
							: 'Запись ID=' + vm.$data.recordId + ' успешно сохранена',
					});
				}
			};
			this.formdataUtil_doSubmit(submitArg);
		},
		/**
		 * Три вида сохранения записи:
		 * - карточка: p_card.vue - getFormdataArg
		 * - список (поэлементное сохранение, дефолтное, по изменению контрола) - ListItem.vue - getSubmitArgument
		 * - список (общее сохранение, с чекбоксами, по нажатию кнопки) - ListItem.vue - getSubmitArgument
		 */
		getFormdataArg: function () {
			var vm = this;
			return {
				armId: vm.$data.armId,
				mode: vm.$data.isNewRecord ? 'create' : 'update',
				fieldList: vm.$data.cardMeta,
				recordId: vm.$data.recordId,
				showExecutedSql: vm.showExecutedSql,
				showExecutedSqlParams: vm.showExecutedSqlParams,
				parentFieldData: this.isNotPopup ? this.childNav_getParentFieldToSet() : {}, // PIRS2018-3101,
				armState: vm.childNav_getArmState(vm.$data.cardMeta, this.recordData),
			};
		},
		gotoArmEdit: function () {
			this.$router.push({
				name: 'armEdit',
				params: {
					armId: this.armId,
				},
			});
		},
		gotoChildArm: function (childArmObj) {
			// (функция из миксина)
			this.childNav_toChild({
				childArmObj,
				parentRecordData: this.recordData,
				isCard: true,
			});
		},
		/**
		 * Проверка поля - нужно ли его выводить
		 * @param field
		 */
		checkField: function (field) {
			if (!field) {
				// поле может быть null
				return false;
			}
			if (field.ctrlCode === 'text_static' && this.isNewRecord) {
				// статические поля в форме новой записи не выводим
				return false;
			}

			// Если текстовое поле нередактируемое, то оно нередактируемое только при редактировании, но не при создании
			if (field.ctrlCode === 'text_input' && field.ctrlParams.isReadOnly === true && this.isNewRecord) {
				field.ctrlParams.isReadOnly = false;
			}

			if (this.checkFieldDynamicGroup(field) === false) {
				return false;
			}

			/*if (field.ctrlCode === 'popup_picker') {
					return false
				}*/
			return true;
		},
		checkChildArm(childArm) {
			// Не показываем поле, если у нас выбрана группа и у поля есть группа и выбранаая группа !== группы у поля
			// Не показываем поле, если у нас не выбрана группа, а у поля есть группа ( последнее или можно убрать )
			if (
				this.isDynamicFields &&
				((!!this.dynamicFieldGroup &&
					!!childArm['dynamicFieldGroup'] &&
					childArm['dynamicFieldGroup'].length &&
					childArm['dynamicFieldGroup'].includes(String(this.dynamicFieldGroup)) === false) ||
					(!this.dynamicFieldGroup && childArm['dynamicFieldGroup'] && childArm['dynamicFieldGroup'].length))
			) {
				// if (this.isDynamicFields && (!!this.dynamicFieldGroup && !!childArm['dynamicFieldGroup'] && this.dynamicFieldGroup !== childArm['dynamicFieldGroup'])) {
				return false;
			}

			return true;
		},
		EXT_setRecordSavePending: function (newVal) {
			// EXT_ означает что дергается снаружи! formdataUtil_doSubmit
			this.recordSavePending = !!newVal;
		},
		onInputEvent: function (optionalPayload) {
			this.draftSaveAction(optionalPayload);
			this.setOtherFields(optionalPayload);
		},
		setOtherFields: function (optionalPayload) {
			// Установка значений других полей для контролов типа адрес ГАР
			if (optionalPayload && optionalPayload.fieldsToSet) {
				for (const dbcolname in optionalPayload.fieldsToSet) {
					const fts = this.$data.cardMeta.find((fi) => fi.dbcolname === dbcolname);
					if (fts) {
						const { newValue } = optionalPayload.fieldsToSet[dbcolname];
						console.log(`Устанавливаем значение колонке ${dbcolname}`, newValue);
						// this.$set(fts, 'value', newValue);
						fts.value = newValue;
					} else console.error(`Установка значения колонки ${dbcolname} невозможна - колонка не найдена`);
				}
			}
		},
		draftSaveAction: function (optionalPayload) {
			this.draftCreated = true;
			var currentFields = this.formdataUtil_getFormData(this.getFormdataArg()).getPayload().records[0].fields;
			draftCommon.updateFullValuesAndMergeItIntoCurrentFields(
				currentFields,
				this.$data._draftFullValues,
				optionalPayload,
			);
			this.$refs.draftSaverRef.EXT_doSave(currentFields);
		},
		draftAcceptAction: function (draftItem) {
			var existingFieldIds = this.cardMeta.map((f) => f.dbcolname);
			// по состоянию на сейчас draftItem.draftData содержит только fields
			var draftFields = JSON.parse(draftItem.draftData).filter(function (df) {
				return existingFieldIds.indexOf(df.fieldId) !== -1;
				// добавляем только те поля, что пришли в оригинальном ответе на запрос данных
			});
			var draftRecordData = preprocessUtil({
				primaryKeyValue: draftItem.recordId,
				fields: draftFields,
				armId: this.armId,
			});
			this.cardMeta = [];
			this.buildFields(draftRecordData);
		},
		draftRemove: function () {
			// удаляем черновик при любом способе покинуть карточку
			// (перезагрузка страницы или переход по vue роутеру)
			if (this.draftCreated === true) {
				draftCommon.doRemove({
					siteId: this.siteId,
					armId: this.armId,
					recordId: this.recordId,
				});
			}
		},
		_handleFetchBrokenLinks() {
			const { armId, recordId } = this;

			axios
				.get(`/analyzer/links/?entityId=${recordId}&armId=${armId}`)
				.then((response) => {
					const {
						data: { links },
					} = response;
					this.brokenLinks = links;
					// console.log('Complete loading broken links', links)
				})
				.catch((error) => {
					const {
						response: { data, status },
					} = error;
					throw new Error(`Error loading broken links`);
				});
		},
		_getBrokenLinksOnFiled(field) {
			if (this.linkAnalyzed && this.brokenLinks.hasOwnProperty(field)) {
				return this.brokenLinks[field];
			}
		},
		_checkIsDisabledField(field) {
			if (this.isDynamicFields && this.isNewRecord === false) {
				const { value } = field;
				const isDynamicFieldGroup = has(field, 'isDynamicFieldGroup') && field.isDynamicFieldGroup === true;
				if (isDynamicFieldGroup) {
					const group = this.dynamicFieldGroups.find((g) => String(g.id) === String(value));
					return group && has(group, 'isNotAddable') && group['isNotAddable'] === true;
				}
			}

			return false;
		},

		// Не показываем поле/разделитель, если у нас выбрана группа и у поля есть группа и выбранаая группа !== группы у поля
		// Не показываем поле/разделитель, если у нас не выбрана группа, а у поля есть группа ( последнее или можно убрать )
		checkFieldDynamicGroup: function (fieldOrDelim) {
			// внимание! возвращается true если показывать надо. Не полез в само условие (перенесенное), просто инвертировал return
			const bHide =
				this.isDynamicFields &&
				((!!this.dynamicFieldGroup &&
					!!fieldOrDelim.dynamicFieldGroup &&
					fieldOrDelim.dynamicFieldGroup.length &&
					fieldOrDelim.dynamicFieldGroup.includes(String(this.dynamicFieldGroup)) === false) ||
					(!this.dynamicFieldGroup && fieldOrDelim.dynamicFieldGroup && fieldOrDelim.dynamicFieldGroup.length));

			// console.log(`checkFieldDynamicGroup:`, fieldOrDelim.name, !bHide, fieldOrDelim.dynamicFieldGroup, this.dynamicFieldGroup);
			return !bHide;
		},
	},
	mixins: [
		childNavMixin, // миксин с childNav_pathArray и методами для перехода в дочерние/родительские АРМ
		formdataUtil.mixin, // миксин с методами сабмита записей
		urlUtil.mixin, // m_indicateFileDownload
	],
	created: function () {
		var debugStorageKey = 'draft-noremove';
		if (window.localStorage.getItem(debugStorageKey)) {
			console.log(
				'!! Удаление черновика при переходе отключено. Чтобы включить, выполни localStorage.removeItem("' +
					debugStorageKey +
					'") и перезайди в карточку',
			);
		} else {
			window.addEventListener('beforeunload', this.draftRemove);
		}
	},
	mounted: function () {
		this.onMount();

		if (this.linkAnalyzed) {
			this._handleFetchBrokenLinks();
		}
		this.$on('update:value:full', (field) => {
			const index = this.cardMeta.findIndex((el) => el.RANDOM_KEY === field.RANDOM_KEY);

			if (index > -1) this.$set(this.cardMeta, index, field);
		});
	},
	beforeDestroy: function () {
		this.draftRemove();
		window.removeEventListener('beforeunload', this.draftRemove);
	},
	beforeRouteUpdate: function (from, to, next) {
		// главная цель - чтобы смена siteId работала (для визарда)
		next();
		Object.assign(this.$data, this.getInstanceData());
		this.onMount();
	},
};

type GotoFilterlistArg = {
	preventUarmListMemSet?: boolean;
	/** Для проверки, что в аргументе передан именно объект опций, в противном случае можно в шаблоне сделать @onclick="gotoFilterlist" и получить аргументом ивент клика */
	isOpt?: true;
};

function orderComparator(a, b) {
	var aOrder = a ? a.order : 0;
	var bOrder = b ? b.order : 0;
	return aOrder - bOrder;
}
